import fileDownload from 'js-file-download';
import http from "@/api.js";

export default {
    name: 'template-mixin',
    emits: ['edit-template', 'edit-document-template'],
    data: () => ({
        template_list: [],
        template_model: null,
        template_name: null,
    }),
    methods: {
        templateUrl(uid){
            return "/api/"+this.$route.params.groupUid+this.documentapi+uid+"/template/";
        },

        async getTemplateList(){
            const response = await http.get("/api/"+this.$route.params.groupUid+"/dataroom/documents/template_list/");
            this.template_list = response.data;
        },
        choiceTemplateModel(template){
            this.template_model = template ? template : {name: "Document vierge"};
        },
        writeTemplateName(name){
            this.template_name = name;
        },
        cancelTemplateChoice(){
            this.template_model = null;
            this.template_name = null;
        },

        // Contextual menu
        actionActionTemplate(template, action){
            http.post(this.templateUrl(template.uid), { action: "action", method: action }).then(() => {
                this.$emit('folder-change', template.folder);
            });
        },
        startEditDocumentTemplate($event){
            this.openModalDataroom('edit-document-template', $event);
        },
        async actionSaveTemplate(raw_template, template){
            var params = {action: "save", raw_template };
            await http.post(this.templateUrl(template.uid), params);
            this.$emit('edit-template', template.folder);
        },
        async actionReplaceTemplate(raw_template, template){
            var params = {action: "template", raw_template };
            await http.post(this.templateUrl(template.uid), params);
            this.$emit('edit-template', template.folder);
        },
        async actionGenerateTemplate(raw_template, template){
            var params = {action: "generate", raw_template, name: template.name };
            await http.post(this.templateUrl(template.uid), params);
            this.$emit('edit-template', template.folder);
        },
        async actionHeaderTemplate(raw_template, template){
            var params = {action: "header", header_enable: template.template_cfg.header_enable };
            await http.post(this.templateUrl(template.uid), params);
            this.$emit('edit-template', template.folder);
        },
        async actionFooterTemplate(raw_template, template){
            var params = {action: "footer", footer_enable: template.template_cfg.footer_enable };
            await http.post(this.templateUrl(template.uid), params);
            this.$emit('edit-template', template.folder);
        },
        async actionDownloadTemplate(raw_template, template){
            var payload = { action: "download", raw_template, name: template.name };
            const response = await http.post(this.templateUrl(template.uid), payload, {responseType: 'arraybuffer'});
            var cd = response.headers["content-disposition"];
            const fn = cd.match("filename=(.+)")[1];
            fileDownload(response.data, fn);
        },
    }
}
